/* ==================================================================
   Fairway Golf USA — FG Visual スライダー
   貼り付け先: assets/fg-landing.js を新規作成し、
   layout/theme.liquid の </body> 直前に

     <script src="{{ 'fg-landing.js' | asset_url }}" defer></script>

   テーマエディタでスライドを足したり並べ替えても効くよう、
   Shopify のセクション再描画イベントで組み直します。
   ================================================================== */

(function () {
  'use strict';

  function initSlider(root) {
    if (!root || root.dataset.fgReady === '1') return;
    root.dataset.fgReady = '1';

    var slides = [].slice.call(root.querySelectorAll('.fg-slide'));
    var dotsBox = root.querySelector('[data-fg-dots]');
    var prev = root.querySelector('[data-fg-prev]');
    var next = root.querySelector('[data-fg-next]');
    if (slides.length < 2) return;

    var index = 0;
    var timer = null;
    var autoplay = root.dataset.autoplay === 'true';
    var interval = parseInt(root.dataset.interval, 10) || 6000;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    var dots = [];
    if (dotsBox) {
      dotsBox.innerHTML = '';
      dots = slides.map(function (s, i) {
        var b = document.createElement('button');
        b.type = 'button';
        b.setAttribute('role', 'tab');
        b.setAttribute('aria-label', 'Slide ' + (i + 1));
        b.setAttribute('aria-selected', i === 0 ? 'true' : 'false');
        b.addEventListener('click', function () { stop(); show(i); });
        dotsBox.appendChild(b);
        return b;
      });
    }

    function show(n) {
      index = (n + slides.length) % slides.length;
      slides.forEach(function (s, i) { s.classList.toggle('is-on', i === index); });
      dots.forEach(function (d, i) { d.setAttribute('aria-selected', i === index ? 'true' : 'false'); });
    }

    function start() {
      if (!autoplay || reduce || timer) return;
      timer = setInterval(function () { show(index + 1); }, interval);
    }

    function stop() { clearInterval(timer); timer = null; }

    if (next) next.addEventListener('click', function () { stop(); show(index + 1); });
    if (prev) prev.addEventListener('click', function () { stop(); show(index - 1); });

    // 見ている間・フォーカス中・タブが裏の間は動かさない
    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);
    root.addEventListener('focusin', stop);
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) { stop(); } else { start(); }
    });

    root.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { stop(); show(index + 1); }
      if (e.key === 'ArrowLeft') { stop(); show(index - 1); }
    });

    show(0);
    start();
  }

  function initAll(scope) {
    var target = scope || document;
    [].slice.call(target.querySelectorAll('[data-fg-slider]')).forEach(initSlider);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  // テーマエディタでセクションを編集すると DOM が差し替わるので、貼り直す
  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
  });
  document.addEventListener('shopify:section:unload', function (e) {
    var root = e.target.querySelector('[data-fg-slider]');
    if (root) root.dataset.fgReady = '';
  });
})();
